import ELocalStorageKeys from "../shared/types/ELocalStorageKeys"

const firstUserAccess = {
  setTrueIfInexistent() {
    const value = JSON.parse(localStorage.getItem(ELocalStorageKeys.IS_FIRST_ACCESS));

    if(value === null) {
      localStorage.setItem(ELocalStorageKeys.IS_FIRST_ACCESS, 'true');
    }
  },
  check(): boolean {
    const value = JSON.parse(localStorage.getItem(ELocalStorageKeys.IS_FIRST_ACCESS));

    return value === true;
  },
  setFalse() {
    localStorage.setItem(ELocalStorageKeys.IS_FIRST_ACCESS, 'false');
  }
}

export default firstUserAccess;
